/*!
 * @Author: leo 
 * @Date: 2021-07-08 11:30:00
 * @Last Modified by: lei 
 * @Last Modified time: 2021-07-08 11:30:00
 * @Introduction: 安全模块路由
 */

const BadInfo = () => import('@/views/security/badInfo.vue')
const BadInfoDetail = () => import('@/views/security/badInfoDetail.vue')
const Complaints = () => import('@/views/security/complaints.vue')
const ComplaintDetail = () => import('@/views/security/complaintDetail.vue')


/* Layout */
import Layout from '@/layout/index.vue'

export default {
    path: '/security',
    component: Layout,
    redirect: '/security/bad-info',
    meta: {
        title: '安全管理',
        icon: 'icon-security',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'bad-info',
            component: BadInfo,
            name: 'BadInfo',
            meta: {
                title: '有害信息'
            }
        },
        {
            path: 'bad-info/:id',
            component: BadInfoDetail,
            name: 'BadInfoDetail',
            meta: {
                title: '有害信息详情',
                hidden: true
            }
        },
        {
            path: 'complaints',
            component: Complaints,
            name: 'Complaints',
            meta: {
                title: '投诉信息'
            }
        },
        {
            path: 'complaint/:id',
            component: ComplaintDetail,
            name: 'ComplaintDetail',
            meta: {
                title: '投诉信息详情',
                hidden: true
            }
        }
    ]
}
